// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bisystem/canvas/main/cells/cell/calendar/calendar.small/calendar.small.week/calendar.small.week.scss
// module id = 4917
// module chunks = 50